import TrackPointsTableWrapper from "./TrackPointsTableWrapper";

const LOAD_MORE_THRESHOLD = 0.9;

const HistoryInfiniteScrollTable = ({
  data = [],
  selectedColumns = [],
  setSelectedColumns,
  setSelectedColumnItems,
  hasMore,
  isLoadingMore,
  onLoadMore,
  variableData,
  tableHandlers = {},
  highlight,
  columnData = [],
}) => {
  return (
    <div className="track-points-history">
      <TrackPointsTableWrapper
        data={data}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        setSelectedColumnItems={setSelectedColumnItems}
        variableData={variableData}
        tableHandlers={tableHandlers}
        highlight={highlight}
        columnData={columnData}
        onScrollFrame={({ top }) => {
          if (top >= LOAD_MORE_THRESHOLD && hasMore && !isLoadingMore) {
            onLoadMore();
          }
        }}
        isLoadingMore={isLoadingMore}
        isEndOfData={!hasMore && !isLoadingMore}
        scrollbarHeight="none"
      />
    </div>
  );
};

export default HistoryInfiniteScrollTable;
